import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'sy-icon-button',
    template: `
        <button mat-icon-button [ngClass]="cssClass" [disabled]="disabled" [matTooltip]="tooltip | localize" (click)="buttonClick.emit()" [style.color]="color">
            <mat-icon class="material-symbols-outlined" >{{icon}}</mat-icon>
        </button>
    `
})
export class ServitlyIconButtonComponent {

    @Input() icon: string;

    @Input() tooltip: string;

    @Input() color: string = 'inherit';

    @Input() disabled: boolean;

    @Input() cssClass: string;

    @Output() buttonClick = new EventEmitter<void>();
}


